import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/pages/Main';
import Content from '@/pages/Content';
import Profile from '@/components/Profile';
import Portfolio from '@/components/Portfolio';
import MarkdownView from '@/components/MarkdownView';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
    },
    {
      path: '/index',
      name: 'Content',
      component: Content,
      children: [
        {
          path: 'profile',
          name: 'Profile',
          component: Profile,
        },
        {
          path: 'portfolio',
          name: 'Portfolio',
          component: Portfolio,
        },
        {
          path: 'portfolio/:repoName',
          name: 'Md-Viewer',
          component: MarkdownView,
        },
      ],
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});




// WEBPACK FOOTER //
// ./src/router/index.js